import React, { useState } from 'react';
import NavContainer from './styles';
import { FaBars } from 'react-icons/fa';
import { NavLink, Link } from 'react-router-dom';
import { links } from '../../utils/constants';
import CartButtons from '../CartButtons';
import { useProductsContext } from '../../context/products_context';
import { useUserContext } from '../../context/user_context';
import SearcIcon from '../../assets/SearchIcon.svg';
import logo from '../../assets/logo.svg';
import mukundalogo from "../../assets/mukundalogo.png"
import newlogo from "../../assets/newlogo.svg"
import PricePopup from '../Popups/PricePopup';

const Nav = () => {
  const { currentUser } = useUserContext();
  const { openSidebar, isPricePopupOpen, openPricePopup, closePricePopup } =
    useProductsContext();
  const [showLinks, setShowLinks] = useState(false);

  return (
    <NavContainer>
      <div className='nav-center'>
        <div className='nav-header'>
          <NavLink to='/'>
            <img src={newlogo} alt='home' />
          </NavLink>
        </div>

        <div className='nav-right'>
          <ul
            className={`nav-links ${showLinks ? 'show' : ''} xl:p-1 md:text-xs`}
          >
            {links.map(({ id, url, text }) => (
              <li key={id}>
                <NavLink to={url}>{text}</NavLink>
              </li>
            ))}
            {currentUser && (
              <li>
                <NavLink
                  to='/orders'
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  Orders
                </NavLink>
              </li>
            )}

            <li
              onClick={openPricePopup}
              className="cursor-pointer" style={{fontSize:"15px"}}
            >
              Today's prices
            </li>
          </ul>

          <div className='cart-btn-wrapper'>
            <CartButtons />
          </div>

          {/* Search and Sidebar toggle (mobile) */}
          <div className='mobile-controls'>
            <Link to='/collections' className='nav-toggle search-icon'>
              <img src={SearcIcon} alt='search' />
            </Link>
            <button type='button' className='nav-toggle' onClick={openSidebar}>
              <FaBars />
            </button>
          </div>
        </div>
        {isPricePopupOpen && <PricePopup />}
      </div>
    </NavContainer>
  );
};

export default Nav;
